export default (state = []) => state;

export const selectors = {
  archivedJobs: state => state.simbot.archivedJobs,
};
